import SearchBar from 'modules/shared/common/components/SearchBar';
import PropTypes from 'prop-types';
import {
  SearchByItemsFitlerLabel,
  SearchByItemsFitlerWrapper,
  SelectedItem,
  SelectedItemClearIcon,
  Label,
} from './SearchByItemsFilter.style';

const SearchByItemsFilter = ({ selectedItems, setSelectedItems, searchApi }) => {
  let selected = { ...selectedItems.productKey };
  return (
    <SearchByItemsFitlerWrapper>
      <SearchByItemsFitlerLabel>Items</SearchByItemsFitlerLabel>
      <SearchBar
        selectHandler={item => {
          const key = item.productKey;
          if (selected[key] !== undefined) delete selected[key];
          else
            selected = {
              ...selected,
              [key]: item?.productNameEn ? item.productNameEn : item?.nameEn,
            };
          setSelectedItems({ ...selectedItems, productKey: selected });
        }}
        objectMapper={item => ({
          name: item?.productNameEn,
          info: item?.newPrice && `${item?.newPrice} EGP`,
        })}
        getData={searchApi}
      />
      {Object.keys(selected).map(itemKey => (
        <SelectedItem key={itemKey}>
          <Label>{selected[itemKey]}</Label>
          <SelectedItemClearIcon
            onClick={() => {
              delete selected[itemKey];
              setSelectedItems({ ...selectedItems, productKey: selected });
            }}
          />
        </SelectedItem>
      ))}
    </SearchByItemsFitlerWrapper>
  );
};

SearchByItemsFilter.propTypes = {
  selectedItems: PropTypes.shape({
    productKey: PropTypes.PropTypes.shape({}),
  }).isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  searchApi: PropTypes.func.isRequired,
};

export default SearchByItemsFilter;
